import React, { useRef } from 'react';

// Shared by desktop shortcuts and Explorer files: native double-click timing,
// single tap on touch, Enter/Space activation, spatial arrow-key navigation.
export default function IconTarget({ onClick, children, isSelected, ...props }) {
    const pointer = useRef('mouse');
    return <div {...props} role="button" aria-pressed={isSelected} tabIndex={0} data-desktop-icon
        onPointerDown={e => { pointer.current = e.pointerType; }}
        onClick={e => onClick?.(e, e.detail === 0 || e.detail === 2 || pointer.current === 'touch')}
        onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault(); e.stopPropagation(); onClick?.(e, true);
            }
            if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) return;
            e.preventDefault();
            const origin = e.currentTarget.getBoundingClientRect();
            const vertical = e.key === 'ArrowUp' || e.key === 'ArrowDown';
            const sign = e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 1;
            const candidates = [...e.currentTarget.parentElement.querySelectorAll('[data-desktop-icon]')]
                .filter(el => el !== e.currentTarget)
                .map(el => {
                    const box = el.getBoundingClientRect();
                    const dx = box.x - origin.x, dy = box.y - origin.y;
                    return { el, forward: (vertical ? dy : dx) * sign, cross: Math.abs(vertical ? dx : dy) };
                }).filter(c => c.forward > 1).sort((a, b) => (a.forward + a.cross * 4) - (b.forward + b.cross * 4));
            candidates[0]?.el.focus();
        }}>{children}</div>;
}
